import type { CartConfig } from '#root/types/config/pages/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    header: 'mb-0 md:mb-4 lg:mb-6',
    headerTitle: 'subtitle-3 md:|subtitle-1',
    headerTotalItems: 'fw-bold flex items-center justify-end <md:text-sm',
    itemsPerShipping: 'md:mb-4 b-grey-50'
  },
  item: {
    links: 'text-sm'
  },
  containerMW: '90rem',
  quickshop: {
    dialogOptions: {
      type: 'panel',
      position: { sm: 'bottom', lg: 'right' }
    }
  }
} satisfies RecursivePartial<CartConfig>
